module.exports = __webpack_public_path__ + "static/media/slider-arrow.34669c39.svg";